import React, { useState } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, Button } from '@heroui/react';
import { Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import MediaLibraryContainer from '../media-library/MediaLibraryContainer';
import FileUploadField from '../../components/base/FileUploadField';
import { FileMetadata } from '../../services/apis/files';
import { AcceptedFileType, FileUploadTabType } from '../../components/base/file-upload/utils';
import { useQueryClient } from '@tanstack/react-query';
import { fileKeys } from '../../hooks/queries/useFiles';

const MediaContainer: React.FC = () => {
  const { t } = useTranslation('admin');
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const queryClient = useQueryClient();

  const handleFileUploaded = async (fileMetadata: FileMetadata) => {
    // Invalidate the files query to refresh the media library
    await queryClient.invalidateQueries({ queryKey: fileKeys.lists() });
    setIsUploadModalOpen(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{t('media.title', { defaultValue: 'Media Library' })}</h2>
        <Button
          color="primary"
          startContent={<Upload className="w-4 h-4" />}
          onPress={() => setIsUploadModalOpen(true)}
        >
          {t('media.upload', { defaultValue: 'Upload Media' })}
        </Button>
      </div>

      <MediaLibraryContainer
        acceptedTypes={[AcceptedFileType.IMAGE, AcceptedFileType.VIDEO, AcceptedFileType.PDF]}
      />

      <Modal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        size="2xl"
        placement="center"
        scrollBehavior="inside"
      >
        <ModalContent>
          <ModalHeader>
            {t('media.upload', { defaultValue: 'Upload Media' })}
          </ModalHeader>
          <ModalBody className="pb-6">
            <FileUploadField
              file={null}
              onChange={() => {}}
              acceptedTypes={[AcceptedFileType.IMAGE, AcceptedFileType.VIDEO, AcceptedFileType.PDF]}
              maxSize={100}
              shownTabs={[FileUploadTabType.FILE_UPLOAD, FileUploadTabType.EXTERNAL_URL]}
              isMediaLibrary={true}
              onFileUploaded={handleFileUploaded}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default MediaContainer;
